import router from '@/router'
import i18n from '@/i18n'
import { LANGUAGES, COUNTRIES, DEFAULT_COUNTRY } from '@/configs/constants'

const state = {
  language: i18n.locale,
  country: DEFAULT_COUNTRY.code
}

const getters = {
  isZandoSelected: state => (state.country === COUNTRIES.ZA.code)
}

const actions = {
  setLanguage ({ commit }, { language }) {
    language = findLanguageOrGetDefault(language)
    commit('setLanguage', { language })
    i18n.locale = language
    setRouterParameterLanguage(language)
    return Promise.resolve(language)
  },
  setCountry ({ commit }, { countryCode }) {
    countryCode = findCountryOrGetDefault(countryCode)
    commit('setCountry', { countryCode })
    setRouterParameterCountry(countryCode)
    return Promise.resolve(countryCode)
  }
}

const mutations = {
  setLanguage (state, { language }) {
    state.language = language
  },
  setCountry (state, { countryCode }) {
    state.country = countryCode
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

function setRouterParameterLanguage (language) {
  if (router.history.current.params.language && router.history.current.params.language !== language) {
    router.push({ params: { language } })
  }
}

function setRouterParameterCountry (country) {
  if (router.history.current.params.country && router.history.current.params.country !== country) {
    router.push({ params: { country } })
  }
}

function findLanguageOrGetDefault (language) {
  if (LANGUAGES[language.toUpperCase()]) {
    return language
  } else {
    return 'en'
  }
}

function findCountryOrGetDefault (country) {
  if (COUNTRIES[country.toUpperCase()]) {
    return country
  } else {
    return 'ng'
  }
}
